import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (category: typeof categories[0]) => {
    setSelected(category.name);
    setIsOpen(false);
    window.open(category.url, '_blank');
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <p className="font-heading text-xs md:text-sm uppercase tracking-widest text-primary-600 font-semibold mb-3">
          Browse Categories
        </p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          Explore Our Sugargoo Spreadsheet
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-xl mx-auto">
          Select a category below to browse curated products on the Sugargoo Spreadsheet database.
        </p>

        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full sm:w-96 mx-auto flex items-center justify-between px-5 py-3.5 rounded-xl bg-background-50 border-2 border-background-200 hover:border-primary-300 transition-colors text-left cursor-pointer"
          >
            <span className={`text-sm ${selected ? 'text-foreground-900 font-medium' : 'text-foreground-400'}`}>
              {selected || 'Choose a product category...'}
            </span>
            <i className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
          </button>

          {isOpen && (
            <div className="absolute top-full mt-2 left-0 right-0 sm:w-96 sm:mx-auto bg-background-50 rounded-xl border border-background-200 shadow-lg overflow-hidden z-50 max-h-80 overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleSelect(cat)}
                  className="w-full flex items-center gap-3 px-5 py-3 hover:bg-primary-50 transition-colors text-left cursor-pointer border-b border-background-100 last:border-b-0"
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <span className="text-sm text-foreground-800 font-medium">{cat.name}</span>
                  <i className="ri-arrow-right-up-line text-foreground-400 text-xs ml-auto"></i>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}